/* This example requires Tailwind CSS v2.0+ */
import { Fragment, useState } from 'react';
import { Dialog, Transition } from '@headlessui/react';

import {
  HomeIcon,
  MenuIcon,
  UsersIcon,
  LogoutIcon,
  ClipboardIcon,
  CalendarIcon,
  XIcon,
} from '@heroicons/react/outline';
import { Switch, Route, Link, useRouteMatch, useLocation } from 'react-router-dom';
import Election from './Election';
import Profile from './Profile';
import Report from './Report';
import Formats from './Formats';
import { classNames } from 'utils';

const Menu = () => {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const { path, url } = useRouteMatch();
  const location = useLocation();
  const navigation = [
    { name: 'Datos Personero', to: url, icon: HomeIcon, current: url === location },
    {
      name: 'Registro de Lista',
      to: `${url}/formularios`,
      icon: UsersIcon,
      current: `${url}/formularios` === location,
    },
    {
      name: 'Formatos de Inscripción',
      to: `${url}/formatos`,
      icon: ClipboardIcon,
      current: `${url}/formatos` === location,
    },
    {
      name: 'Cronograma electoral',
      to: `${url}/cronograma`,
      icon: CalendarIcon,
      current: `${url}/cronograma` === location,
    },
    {
      name: 'Salir',
      to: `/logout`,
      icon: LogoutIcon,
    },
  ];

  return (
    <div className="flex overflow-hidden bg-gray-100">
      <Transition.Root show={sidebarOpen} as={Fragment}>
        <Dialog
          as="div"
          className="fixed inset-0 flex z-40 md:hidden"
          onClose={setSidebarOpen}
        >
          <Transition.Child
            as={Fragment}
            enter="transition-opacity ease-linear duration-300"
            enterFrom="opacity-0"
            enterTo="opacity-100"
            leave="transition-opacity ease-linear duration-300"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <Dialog.Overlay className="fixed inset-0 bg-gray-600 bg-opacity-75" />
          </Transition.Child>
          <Transition.Child
            as={Fragment}
            enter="transition ease-in-out duration-300 transform"
            enterFrom="-translate-x-full"
            enterTo="translate-x-0"
            leave="transition ease-in-out duration-300 transform"
            leaveFrom="translate-x-0"
            leaveTo="-translate-x-full"
          >
            <div className="relative flex-1 flex flex-col max-w-xs w-full bg-red-900">
              <Transition.Child
                as={Fragment}
                enter="ease-in-out duration-300"
                enterFrom="opacity-0"
                enterTo="opacity-100"
                leave="ease-in-out duration-300"
                leaveFrom="opacity-100"
                leaveTo="opacity-0"
              >
                <div className="absolute top-0 right-0 -mr-12 pt-2">
                  <button
                    type="button"
                    className="ml-1 flex items-center justify-center h-10 w-10 rounded-full focus:outline-none focus:ring-2 focus:ring-inset focus:ring-white"
                    onClick={() => setSidebarOpen(false)}
                  >
                    <span className="sr-only">Cerrar Menú</span>
                    <XIcon className="h-6 w-6 text-white" aria-hidden="true" />
                  </button>
                </div>
              </Transition.Child>
              <div className="flex-1 h-0 pt-5 pb-4 overflow-y-auto">
                <div className="flex-shrink-0 flex items-center px-4">
                  <img className="h-8 w-auto" src="/ceuni_logo.png" alt="Workflow" />
                </div>
                <nav className="mt-5 px-2 space-y-1">
                  {navigation.map((item) => (
                    <Link
                      key={item.name}
                      to={item.to}
                      className={classNames(
                        item.current
                          ? 'bg-red-900 text-white'
                          : 'text-white hover:bg-red-900 hover:bg-opacity-75',
                        'group flex items-center px-2 py-2 text-base font-medium rounded-md',
                      )}
                    >
                      <item.icon
                        className="mr-4 flex-shrink-0 h-6 w-6 text-red-300"
                        aria-hidden="true"
                      />
                      {item.name}
                    </Link>
                  ))}
                </nav>
              </div>
              <div className="flex-shrink-0 flex border-t border-red-800 p-4">
                <div className="flex items-center">
                  <div>
                    {/*
                      <img
                        className="inline-block h-10 w-10 rounded-full"
                        src="https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80"
                        alt=""
                      />
                     */}
                  </div>
                  <div className="ml-3">
                    <p className="text-base font-medium text-white">Personero</p>
                  </div>
                </div>
              </div>
            </div>
          </Transition.Child>
          <div className="flex-shrink-0 w-14" aria-hidden="true">
            {/* Force sidebar to shrink to fit close icon */}
          </div>
        </Dialog>
      </Transition.Root>

      {/* Static sidebar for desktop */}
      <div className="h-screen hidden bg-red-900 md:flex md:flex-shrink-0 print:hidden">
        <div className="flex flex-col w-64">
          {/* Sidebar component, swap this element with another sidebar if you like */}
          <div className="flex-1 flex flex-col min-h-0">
            <div className="flex-1 flex flex-col pt-5 pb-4 overflow-y-auto">
              <div className="flex items-center flex-shrink-0 px-4">
                <img className="h-8 w-auto" src="/ceuni_logo.png" alt="Workflow" />
              </div>
              <nav className="flex flex-col mt-5 flex-1 px-2">
                {navigation.map((item) => (
                  <Link
                    key={item.name}
                    to={item.to}
                    className={classNames(
                      item.current
                        ? 'bg-red-800 text-white'
                        : 'text-white hover:bg-red-600 hover:bg-opacity-75',
                      'group flex items-center px-2 py-2 text-sm font-medium rounded-md',
                    )}
                  >
                    <item.icon
                      className="mr-3 flex-shrink-0 h-6 w-6 text-red-300"
                      aria-hidden="true"
                    />
                    {item.name}
                  </Link>
                ))}
                <div className="ml-2 text-body mt-auto text-white">
                  <div>Teléfono: 3813900</div>
                  <div>Anexo: 7800</div>
                </div>
              </nav>
            </div>
            <div className="flex-shrink-0 flex border-t border-red-800 p-4">
              <div className="flex items-center">
                <div>
                  {/*
                    <img
                      className="inline-block h-9 w-9 rounded-full"
                      src="https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80"
                      alt=""
                    />
                  */}
                </div>
                <div className="ml-3">
                  <p className="text-sm font-medium text-white">Personero</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="flex flex-col w-0 flex-1 overflow-hidden">
        <div className="md:hidden pl-1 pt-1 sm:pl-3 sm:pt-3 print:hidden">
          <button
            type="button"
            className="-ml-0.5 -mt-0.5 h-12 w-12 inline-flex items-center justify-center rounded-md text-gray-500 hover:text-gray-900 focus:outline-none focus:ring-2 focus:ring-inset focus:ring-red-500"
            onClick={() => setSidebarOpen(true)}
          >
            <span className="sr-only">Open sidebar</span>
            <MenuIcon className="h-6 w-6" aria-hidden="true" />
          </button>
        </div>
        <main className="flex-1 relative z-0 overflow-y-auto focus:outline-none">
          <div className="py-6 min-h-screen">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 md:px-8">
              <div className="py-4">
                <Switch>
                  <Route exact path={path}>
                    <Profile />
                  </Route>
                  <Route exact path={`${path}/reporte`}>
                    <Election />
                  </Route>
                  <Route exact path={`${path}/formularios`}>
                    <Election />
                  </Route>
                  <Route exact path={`${path}/formatos`}>
                    <Formats />
                  </Route>
                  <Route exact path={`${path}/cronograma`}>
                    <>
                      <div className="w-full h-full">
                        <img
                          className="m-auto"
                          src="https://inscripciones-ceuni.s3.amazonaws.com/formatos/cronograma_ceuni_2022_2.jpeg"
                          alt="cronograma"
                        />
                      </div>
                    </>
                  </Route>
                  <Route exact path={`${path}/reporte/inscripcion-personero`}>
                    <Report />
                  </Route>
                </Switch>
              </div>
            </div>
          </div>
        </main>
      </div>
    </div>
  );
};
export default Menu;
